import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { checkAuth, generateCookie, getOriginParam } from "../../utils/data";
import env from "../../utils/env";

import {
  setUserData,
  setUsername,
  setPassword
} from "../../actions/userActions";
import { setViewMessages, showPrompt } from "../../actions/viewActions";
import { emailRegex, notEmptyRegex } from "../../utils/regex";

import "./Home.css";

const lostPasswordLink = env.shopLostPwdURL;
const customerCareLink = "https://support.fabfitfun.com/hc/en-us/requests/new";
const defaultMsg = (
  <span>
    The username or password you entered is incorrect.{" "}
    <a href={lostPasswordLink}>Lost your password?</a>
  </span>
);

const resetPwdPromptMessage = (
    <div className="reset-pwd-prompt">
        <div className="title">
            Password Reset Required
        </div>
        <div className="content">
            As a security measure, we are requiring you to reset your password. Please click below to continue with your reset.
        </div>
        <div className="reset-btn">
            <a className="login-page-button" href={lostPasswordLink}>RESET YOUR PASSWORD</a>
        </div>
        <div className="note">
            Already reset? If you're still having trouble logging in, please <a href={customerCareLink}>contact us</a> or <a href={lostPasswordLink}>reset again</a>. 
        </div>
    </div>
);

class Home extends Component {
  state = {
    loggingIn: false,
  };

  componentWillMount() {}

  componentDidMount() {
  }

  handleUpdateUsername = e => {
    this.props.setUsername(e.target.value);
  };

  handleUpdatePassword = e => {
    this.props.setPassword(e.target.value);
  };

  handleLogin = () => {
    // Validation
    const origin = getOriginParam();
    const isEmail = emailRegex.test(this.props.username);
    const isPassword = notEmptyRegex.test(this.props.password);
    const inputValidation = [];
    const existsEmail = notEmptyRegex.test(this.props.username);

    this.props.setViewMessages([]);
    if (!isEmail) {
      if (!existsEmail) {
        inputValidation.push("Username is required.");
      } else {
        this.props.setViewMessages([defaultMsg]);
        return;
      }
    }
    if (!isPassword) {
      if (existsEmail) {
        inputValidation.push("Please enter your password");
      } else {
        inputValidation.push("Password is required.");
      }
    }
    if (!isEmail || !isPassword) {
      this.props.setViewMessages(inputValidation);
      return;
    }

    // Fetch cookie
    const { username, password } = this.props;
    this.setState({...this.state, loggingIn: true});
    generateCookie(username, password).then(res => {
      this.setState({...this.state, loggingIn: false});  
      if (!!res.status) {
        switch (res.status) {
          case 401:
            if (this.props.showPwdResetRequiredPrompt) {
                this.props.showPrompt(resetPwdPromptMessage);
            } else {
                this.props.setViewMessages([defaultMsg]);
            }
            break;

          case 400:
            checkAuth(res => {
              if (!origin || !res.ok) {
                // Message if origin param is missing
                this.props.setViewMessages([
                  <span>
                    Sorry, there was an error logging you in. Please{" "}
                    <a href={lostPasswordLink}>click here </a> to reset your
                    password or reach out to{" "}
                    <a href="https://fabfitfun.com/concierge/">
                      Customer Care.
                    </a>
                  </span>
                ]);
              } else {
                window.location = env.envURL;
              }
            });
            break;

          case 200:
            window.location = origin;
            break;

          default:
            this.props.setViewMessages([defaultMsg]);
        }
      }
    });
  };

  _handleKeyPress = e => {
    if (e.key === "Enter") {
      this.handleLogin();
    }
  };

  render() {
    const {
      _handleKeyPress,
      handleUpdateUsername,
      handleUpdatePassword,
      handleLogin
    } = this;

    return (
      <React.Fragment>
        <div className="login-page mar-a" onKeyPress={_handleKeyPress}>
          <div className="login">
            <h2 className="login-page-h2">Member login</h2>
            <form>
              {this.props.promptMessage ? (<div>{this.props.promptMessage}</div>) : ""}
              <div className="labelpair">
                <label htmlFor="username">
                  Email Address
                  <span>*</span>
                </label>
                <input name="username" onChange={handleUpdateUsername} />
              </div>
              <div className="labelpair">
                <label htmlFor="password">
                  Password
                  <span>*</span>
                </label>
                <input
                  name="password"
                  type="password"
                  onChange={handleUpdatePassword}
                />
              </div>
              <div className="messages">
                {this.props.messages.map((msg, index) => (
                  <div className="message" key={"message-" + index}>
                    <b>ERROR:</b> {msg}
                  </div>
                ))}
              </div>
              {this.state.loggingIn ? (
                  <button
                  className="login-page-button"
                  type="button"
                  disabled
                >
                  Logging In...
                </button>
              ) : (
                    <button
                    className="login-page-button"
                    onClick={handleLogin}
                    type="button"
                >
                    Login
                </button>
              )}
              
            </form>
            <div className="links">
              {/* <div className="check">
                <input
                  type="checkbox"
                  name="remember"
                  id="remember"
                  defaultChecked
                />
                <label htmlFor="remember">Remember me</label>
              </div> */}
              <a href={lostPasswordLink} className="lost">
                Forgot your password?
              </a>
            </div>
            <h4 className="bottom">
              Not a member yet?{" "}
              <a href={`${env.envURL}/get-the-box/#getstarted`}>Sign up now</a>
            </h4>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mS = state => ({
  username: state.user.username,
  password: state.user.password,
  user: state.user,
  isMobile: state.view.isMobile,
  messages: state.view.messages,
  promptMessage: state.view.promptMessage,
  showPwdResetRequiredPrompt: state.launchDarkly.showPwdResetRequiredPrompt,
});

const mD = dispatch =>
  bindActionCreators(
    {
      setUserData,
      setUsername,
      setPassword,
      setViewMessages,
      showPrompt
    },
    dispatch
  );

export default connect(
  mS,
  mD
)(Home);
